import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';
import {alto, codGray} from '/theme/color/secondary.color';

export default StyleSheet.create({
  container: {
    height: 120,
    borderTopWidth: 1,
    borderColor: alto,
  },
  button: {
    height: 40,
    borderColor: alto,
    borderRadius: 8,
    backgroundColor: white,
    justifyContent: 'center',
    borderWidth: 1,
    marginHorizontal: 18,
    marginTop: 25,
  },
  buttonStyle: {
    flexDirection: 'row',
  },
  buttonText: {
    color: codGray,
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
    flex: 1,
    //width: 350,
  },
});
